import { Skeleton } from '@typings';

import { SkeletonBase } from '../SkeletonBase';

import styles from './InputSkeleton.module.scss';

export const InputSkeleton = ({ color }: Skeleton.InputSkeleton) => <SkeletonBase className={styles.inputSkeleton} color={color} />;
